import type { FC } from 'react';
import { Navigate, useParams } from 'react-router';
import FormSkeleton from './FormSkeleton';
import { SuspenseBoundary } from 'components/common';
import { cabinetDatadogSources } from 'lib/datadog';
import AddFacebookPageForm from './AddFacebookPageForm';
import { useFacebookPageDetails } from '../api/getFacebookPageDetails';

const AddFacebookPageComponent: FC = () => {
  const { facebookId } = useParams();
  const { data } = useFacebookPageDetails({ params: { id: facebookId } });

  if (!facebookId) return <Navigate to={'/'} />;
  return <AddFacebookPageForm data={data} />;
};

const EditFacebookPage: FC = () => {
  return (
    <SuspenseBoundary
      fallback={<FormSkeleton />}
      datadogSource={cabinetDatadogSources.detailsQuery('facebook', 'facebook_page')}
    >
      <AddFacebookPageComponent />
    </SuspenseBoundary>
  );
};

export default EditFacebookPage;
